import { type FieldContentsData } from 'javascripts/shared-types';
import Field, { type Flavor } from '../../Field';
import terminology from 'javascripts/terminology';

export class GoalName extends Field {
  static get availableForFlavors(): readonly Flavor[] {
    return ['roadmap'];
  }

  static subqueriesForModel() {
    return { goals: ['name'] };
  }

  get title() {
    return `${terminology('Goal')} name`;
  }

  exampleContents(): FieldContentsData {
    return { text: `Example ${terminology('goal')}` };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.goals?.length) {
      return {
        text: record.goals[0].name,
      };
    }

    return {};
  }
}
